var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElipse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1_6490",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62 31C62 48.1208 48.1208 62 31 62C13.8792 62 0 48.1208 0 31C0 13.8792 13.8792 0 31 0C48.1208 0 62 13.8792 62 31ZM0.929998 31C0.929998 47.6072 14.3928 61.07 31 61.07C47.6072 61.07 61.07 47.6072 61.07 31C61.07 14.3928 47.6072 0.929998 31 0.929998C14.3928 0.929998 0.929998 14.3928 0.929998 31Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62 31C62 48.1208 48.1208 62 31 62C13.8792 62 0 48.1208 0 31C0 13.8792 13.8792 0 31 0C48.1208 0 62 13.8792 62 31ZM0.929998 31C0.929998 47.6072 14.3928 61.07 31 61.07C47.6072 61.07 61.07 47.6072 61.07 31C61.07 14.3928 47.6072 0.929998 31 0.929998C14.3928 0.929998 0.929998 14.3928 0.929998 31Z",
    stroke: "#262626",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_1_6490)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElipse);
export default __webpack_public_path__ + "static/media/elipse.d0450f97622cb68781bbf3f1ba68fe3d.svg";
export { ForwardRef as ReactComponent };